import React from 'react';
import { Link } from 'react-router-dom';

const PhotoOrders = () => {
  return (
    <section className="photo-orders page-section">
      <span className="section-label">Kuvatilaukset</span>
      <h1 className="section-heading">Tilaa valmiita otoksia julkaisuun</h1>
      <p className="section-subtitle">
        Saat käyttöösi curated-arkistoni tapahtumista, tuotteista ja arkkitehtuurista. Kaikki kuvat toimitetaan
        julkaisuvalmiina, metatiedoilla sekä käyttöoikeusmerkinnällä.
      </p>
      <ul>
        <li>Valitse teema: tapahtumat, ihmiset, tuotteet tai kaupunkimaisemat.</li>
        <li>Hyväksy ehdotus ja vastaanota linkki suojattuun latauskansioon.</li>
        <li>Lisäpalveluna voin editoida kuvat brändipalettiisi sopiviksi.</li>
      </ul>
      <p>
        <Link to="/contact" className="btn btn-primary">Pyydä galleria</Link>
      </p>
    </section>
  );
};

export default PhotoOrders;
